module.exports = __webpack_public_path__ + "img/Hero_image_mobile.37f685a9.png";